import { z } from "zod";

export const zAttrTimePicker = z.object({
  editor: z.literal("TimePicker"),
});

export type ZAttrTimePicker = z.infer<typeof zAttrTimePicker>;
